import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    borderRadius: "16px !important",
    overflow: "hidden !important",
    maxWidth: "640px !important",
    width: "100% !important",
  },
  headerBar: {
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    padding: "14px 24px !important",
    display: "flex !important",
    alignItems: "center !important",
    justifyContent: "space-between !important",
  },
  headerTitle: {
    fontSize: "18px !important",
    fontWeight: "600 !important",
    color: "#ffffff !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  closeIconBtn: {
    color: "#ffffff !important",
    padding: "4px !important",
  },
  contentContainer: {
    padding: "32px 40px !important",
    backgroundColor: "#ffffff",
  },
  sectionTitle: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    color: "#111111",
    marginBottom: "16px !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  uploadBox: {
    border: "2px dashed #b0b0b0",
    borderRadius: "16px",
    backgroundColor: "#f9f9f9",
    padding: "24px 20px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "20px",
    transition: "border-color 0.2s, background-color 0.2s",
    minHeight: "140px",
    "&:hover": {
      borderColor: "#777777",
      backgroundColor: "#f0f0f0",
    },
  },
  uploadIcon: {
    fontSize: "36px !important",
    color: "#666666",
    marginBottom: "8px !important",
  },
  uploadText: {
    fontSize: "14px !important",
    color: "#777777 !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  previewImage: {
    maxWidth: "100%",
    maxHeight: "120px",
    objectFit: "contain",
    borderRadius: "8px",
  },
  fieldLabel: {
    fontSize: "14px !important",
    fontWeight: "600 !important",
    color: "#444444 !important",
    marginBottom: "6px !important",
    marginTop: "12px !important",
    fontFamily: "'Inter', sans-serif !important",
  },
  textField: {
    marginBottom: "12px !important",
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px !important",
      backgroundColor: "#ffffff",
      fontFamily: "'Inter', sans-serif !important",
      "& fieldset": {
        borderColor: "#d0d5dd",
      },
      "&:hover fieldset": {
        borderColor: "#98a2b3",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#000000",
      },
    },
  },
  buttonContainer: {
    display: "flex",
    gap: "16px",
    justifyContent: "center",
    marginTop: "28px",
  },
  cancelBtn: {
    minWidth: "140px !important",
    height: "44px !important",
    borderRadius: "8px !important",
    textTransform: "none !important",
    borderColor: "#b0b0b0 !important",
    color: "#333333 !important",
    fontWeight: "600 !important",
    fontSize: "14px !important",
    fontFamily: "'Inter', sans-serif !important",
    "&:hover": {
      borderColor: "#777777 !important",
      backgroundColor: "#f5f5f5 !important",
    },
  },
  submitBtn: {
    minWidth: "160px !important",
    height: "44px !important",
    borderRadius: "8px !important",
    textTransform: "none !important",
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    fontWeight: "600 !important",
    fontSize: "14px !important",
    fontFamily: "'Inter', sans-serif !important",
    boxShadow: "none !important",
    "&:hover": {
      backgroundColor: "#222222 !important",
      boxShadow: "none !important",
    },
  },
}));

export default useStyles;
